import React, { useState } from "react";
import { Questions, PlusIcn, Answers } from "./questionsItem.styles";
const QuestionsItem = ({ questions }) => {
  const [visible, setVisible] = useState(false);
  console.log("questions", questions);
  return (
    <Questions onClick={() => setVisible(!visible)}>
      <PlusIcn>
        <div className="ml-2">{visible ? "-" : "+"}</div>
        {questions.question}
      </PlusIcn>
      <Answers className={visible ? "" : "d-none"}>{questions.answer}</Answers>
    </Questions>
  );
};

export default QuestionsItem;
